import { Grid } from '@mui/material';
import { getMarkerAttachmentSrc } from '../../utils/complaintAttachment';

const defaultImgStyle = {
    width: '100%',
    maxWidth: '200px',
    maxHeight: '200px',
    objectFit: 'contain',
    borderRadius: '5px',
    border: '1px solid #ddd',
    backgroundColor: '#fff',
};

/**
 * Renders complaint attachment image when Attachment/attachment is present.
 * @param {object} props
 * @param {object} props.complaint - complaint / marker object (or array item)
 * @param {boolean} [props.useGrid=true] - wrap in MUI Grid item
 * @param {object} [props.gridProps] - Grid item props
 * @param {object} [props.labelStyle] - label paragraph style
 * @param {object} [props.wrapperStyle] - used when useGrid is false
 * @param {object} [props.imgStyle] - override image styles
 */
const ComplaintAttachmentImage = ({
    complaint,
    useGrid = true,
    gridProps = { xs: 12, sm: 6, md: 3 },
    labelStyle = { padding: '5px 0px', fontWeight: '500' },
    wrapperStyle,
    imgStyle,
}) => {
    const src = getMarkerAttachmentSrc(complaint);
    if (!src) return null;

    const content = (
        <>
            <p style={labelStyle}>Attachment: </p>
            <img
                src={src}
                alt="Complaint attachment"
                style={{ ...defaultImgStyle, ...imgStyle }}
            />
        </>
    );

    if (!useGrid) {
        return <div style={wrapperStyle}>{content}</div>;
    }

    return (
        <Grid item {...gridProps}>
            {content}
        </Grid>
    );
};

export default ComplaintAttachmentImage;
